import StorageService from "../services/StorageService";
import { buildLoginPath } from "./authRedirect";
import { userHasSellerCapability } from "./roleSwitcher";

/** Buyer RFQ creation / quick RFQ form */
export const BUYER_RFQ_POST_PATH = "/buyer-rfq-form";

/** Supplier registration for guests */
export const SUPPLIER_REGISTRATION_PATH = "/signup";

/** Supplier profile for registered / logged-in users */
export const SUPPLIER_PROFILE_PATH = "/seller-profile";

/** Contract manufacturer profile for registered / logged-in users */
export const MANUFACTURER_PROFILE_PATH = "/contract-manufacturer-profile";

/** Auction listing browse page */
export const AUCTION_LISTING_PATH = "/auction";

/**
 * Navigate logged-in users to the buyer RFQ post form; guests go to login first.
 * @param {(path: string, options?: object) => void} navigate
 */
export function goToBuyerRfqPost(navigate) {
  if (!StorageService.isAuthenticated()) {
    navigate(buildLoginPath(BUYER_RFQ_POST_PATH));
    return;
  }
  navigate(BUYER_RFQ_POST_PATH);
}

/** Quick RFQ creation uses the same buyer RFQ form. */
export function goToQuickRfqCreation(navigate) {
  goToBuyerRfqPost(navigate);
}

/**
 * Guests go to supplier signup; logged-in users go to seller profile to list/manage supplier details.
 * @param {(path: string, options?: object) => void} navigate
 */
export function goToSupplierRegistration(navigate) {
  if (!StorageService.isAuthenticated()) {
    navigate(SUPPLIER_REGISTRATION_PATH);
    return;
  }
  navigate(SUPPLIER_PROFILE_PATH);
}

/**
 * Guests go to signup; logged-in users go to contract manufacturer profile.
 * @param {(path: string, options?: object) => void} navigate
 */
export function goToManufacturerRegistration(navigate) {
  if (!StorageService.isAuthenticated()) {
    navigate(SUPPLIER_REGISTRATION_PATH);
    return;
  }
  navigate(MANUFACTURER_PROFILE_PATH);
}

/** Public auction listing page. */
export function goToAuctionListing(navigate) {
  navigate(AUCTION_LISTING_PATH);
}

/**
 * Guests see List as Supplier; logged-in users only when they have Seller or Both role.
 */
export function shouldShowListAsSupplierButton(user = StorageService.getUser()) {
  if (!StorageService.isAuthenticated()) return true;
  return userHasSellerCapability(user);
}
